import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ShoppingBag, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { gbp } from "@/lib/pricing";

const lineLabel = (it) => {
  if (it.type === "mixbox") return `${it.bottle_count} × ${it.size_label} box`;
  if (it.type === "guest") return `${it.quantity} × ${it.flavor_name}${it.size_label ? ` ${it.size_label}` : ""}`;
  if (it.type === "single") return `${it.quantity} × ${it.flavor_name} ${it.size_label}`;
  if (it.type === "offer") return `${it.quantity} × ${it.flavor_name} ${it.size_label} (offer)`;
  return `${it.quantity} × ${it.name}`;
};
const lineTotal = (it) => (it.type === "mixbox" ? (it.box_price ?? it.unit_price * it.bottle_count) : it.unit_price) * it.quantity;

// Shared "what's in your basket" block for the builder summaries — appears once a box has been added.
export const BasketPanel = () => {
  const { items, subtotal, removeItem } = useCart();
  const nav = useNavigate();
  if (items.length === 0) return null;
  return (
    <div className="mt-4 border-t border-border pt-4" data-testid="basket-panel">
      <div className="flex items-center justify-between">
        <div className="mono flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-muted-foreground"><ShoppingBag className="h-3.5 w-3.5" /> Your basket</div>
        <span className="mono text-[10px] text-muted-foreground" data-testid="basket-count">{items.reduce((s, i) => s + i.quantity, 0)} item{items.length === 1 && items[0].quantity === 1 ? "" : "s"}</span>
      </div>
      <ul className="mt-2 space-y-1.5" data-testid="basket-items">
        {items.map((it) => (
          <li key={it.key} className="flex items-center justify-between gap-2 text-sm" data-testid={`basket-item-${it.key}`}>
            <span className="truncate text-muted-foreground">{lineLabel(it)}</span>
            <span className="flex shrink-0 items-center gap-2">
              <span className="mono font-bold">{gbp(lineTotal(it))}</span>
              <button onClick={() => removeItem(it.key)} aria-label="Remove" data-testid={`basket-remove-${it.key}`} className="text-muted-foreground hover:text-destructive"><X className="h-3.5 w-3.5" /></button>
            </span>
          </li>
        ))}
      </ul>
      <div className="mt-3 flex items-end justify-between border-t border-border pt-3">
        <span className="text-sm font-semibold">Basket total</span>
        <span className="mono font-heading text-2xl font-black text-primary" data-testid="basket-total">{gbp(subtotal)}</span>
      </div>
      <button onClick={() => nav("/checkout")} data-testid="basket-checkout-btn"
        className="mt-3 flex w-full items-center justify-center gap-2 bg-foreground py-3.5 text-sm font-semibold text-background transition-transform hover:-translate-y-0.5">
        Checkout <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
};
